import React from "react";
import { AmountFormat } from "components/common/formatter";

const MatterClientAccount = ({ currentmattersBal }) => {
  return (
    <table
      className="balance-table matter-balance-table"
      // height="100%"
      style={{ width: "100%" }}
    >
      <thead>
        <tr>
          <th>BALANCES</th>
          <th style={{ width: "10px" }}></th>
          <th className="text-center text-truncate">Office Bal</th>
          <th className="text-center text-truncate">Client Bal</th>
          <th className="text-center text-truncate">DDA Bal</th>
          <th className="text-center text-truncate">UP Bills</th>
          <th className="text-center text-truncate">WIP</th>
          <th className="text-center text-truncate">U/T</th>
        </tr>
      </thead>
      <tbody>
        <tr className="">
          <td style={{ fontSize: "12px", minWidth: "80px" }}>This Matter</td>
          <td></td>
          <AmountTD value={currentmattersBal.matterBalances?.officeBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.clientBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.ddaBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.unpaidBills} />
          <AmountTD value={currentmattersBal.matterBalances?.wipBalance} />
          <AmountTD value={currentmattersBal.matterBalances?.undertakingBalance} />
        </tr>
        <tr>
          <td style={{ fontSize: "12px" }}>All Matters</td>
          <td></td>
          <AmountTD value={currentmattersBal.clientBalances?.officeBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.clientBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.ddaBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.unpaidBills} />
          <AmountTD value={currentmattersBal.clientBalances?.wipBalance} />
          <AmountTD value={currentmattersBal.clientBalances?.undertakingBalance} />
        </tr>
      </tbody>
    </table>
  );
};

export default MatterClientAccount;

const AmountTD = ({ value }) => {
  return (
    <td className="text-center pe-1" style={{ width: "90px" }}>
      {AmountFormat(value)}
    </td>
  );
};
